/* ============================================================
   EAGLE & PLATYPUS — SHOPIFY THEME JS
   ============================================================ */

(function() {
  'use strict';

  /* ---------- Cart Drawer ---------- */
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartToggle  = document.getElementById('cart-toggle');
  const cartClose   = document.getElementById('cart-close');

function openCart() {
  if (!cartDrawer) return;
  reloadCartDrawer();
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setTimeout(function() {
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    const overlay = document.getElementById('cart-overlay');
    if (overlay) overlay.classList.add('is-open');
  }, 300);
}

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    const overlay = document.getElementById('cart-overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose)  cartClose.addEventListener('click', closeCart);

  document.addEventListener('click', function(e) {
    if (e.target.id === 'cart-overlay') closeCart();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ---------- Cart Quantity ---------- */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.qty-btn[data-key]');
    if (!btn) return;
    const key    = btn.dataset.key;
    const action = btn.dataset.action;
    const display = btn.parentElement.querySelector('.qty-value');
    let qty = parseInt(display ? display.textContent : 1);
    qty = action === 'remove' ? 0 : action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
    updateCartItem(key, qty);
  });

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      reloadCartDrawer();
    });
  }

  function updateCartCount(count) {
    const badge = document.querySelector('.header__cart-count');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  /* ---------- Quick Add to Cart (product cards) ---------- */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-card__atc');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Added';
      setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1800);
      reloadCartDrawer();
      setTimeout(function() { openCart(); }, 150);
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1800);
    });
  });

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartCount(cart.item_count); });
  }

  function reloadCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        const body = document.getElementById('cart-drawer-body');
        const footer = document.querySelector('.cart-drawer__footer');
        if (!body) return;
        if (cart.item_count === 0) {
          body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--primary">Continue Shopping</a></div>';
          if (footer) footer.style.display = 'none';
        } else {
          let html = '';
          cart.items.forEach(function(item) {
            html += `
              <div class="cart-item" data-key="${item.key}">
                <img src="${item.image}" alt="${item.title}" class="cart-item__image" width="80">
                <div class="cart-item__details">
                  <p class="cart-item__title">${item.product_title}</p>
                  ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
                  <p class="cart-item__price">${formatMoney(item.final_price)}</p>
                  <div class="cart-item__quantity">
                    <button class="qty-btn" data-action="decrease" data-key="${item.key}">–</button>
                    <span class="qty-value">${item.quantity}</span>
                    <button class="qty-btn" data-action="increase" data-key="${item.key}">+</button>
                  </div>
                  <button class="cart-item__remove qty-btn" data-action="remove" data-key="${item.key}">Remove</button>
                </div>
              </div>`;
          });
          body.innerHTML = html;
          if (footer) {
            footer.style.display = 'flex';
            footer.innerHTML = `
              <div class="cart-drawer__subtotal">
                <span>Subtotal</span>
                <span>${formatMoney(cart.total_price)}</span>
              </div>
              <p class="cart-drawer__note">Shipping &amp; taxes calculated at checkout.</p>
              <a href="/checkout" class="btn btn--primary btn--full">Checkout</a>
              <a href="/cart" class="btn btn--ghost btn--full">View Cart</a>
            `;
          }
        }
      });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Mobile Menu ---------- */
  document.addEventListener('DOMContentLoaded', function() {
    const mobileToggle = document.getElementById('mobile-menu-toggle');
    const mobileNav    = document.getElementById('mobile-nav');
    if (mobileToggle && mobileNav) {
      mobileToggle.addEventListener('click', function() {
        const isOpen = mobileNav.classList.toggle('is-open');
        mobileToggle.setAttribute('aria-expanded', isOpen);
      });
    }
  });

  /* ---------- Header Scroll Behaviour ---------- */
  const siteHeader = document.getElementById('site-header');
  if (siteHeader) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const current = window.scrollY;
      if (current > 80) {
        siteHeader.style.borderBottomColor = 'rgba(242,106,27,0.25)';
      } else {
        siteHeader.style.borderBottomColor = '';
      }
      lastScroll = current;
    }, { passive: true });
  }

  /* ---------- Scroll-in Animations ---------- */
  if ('IntersectionObserver' in window) {
    const style = document.createElement('style');
    style.textContent = `
      .ep-reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.7s ease, transform 0.7s ease; }
      .ep-reveal.is-visible { opacity: 1; transform: none; }
    `;
    document.head.appendChild(style);

    const candidates = document.querySelectorAll(
      '.product-card, .colourways__card, .animal-section__text, .animal-section__image, .about-hero__body p, .about-hero__callout'
    );
    candidates.forEach(function(el) { el.classList.add('ep-reveal'); });

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    candidates.forEach(function(el) { observer.observe(el); });
  }
/* ---------- Swatch Image Swap ---------- */
  document.addEventListener('mouseover', function(e) {
    var swatch = e.target.closest('.product-card__swatch[data-image]');
    if (!swatch) return;
    var card = swatch.closest('.product-card');
    var media = card.querySelector('.product-card__media');
    if (!media) return;
    var existing = media.querySelector('.swatch-preview');
    if (existing) existing.remove();
    var img = document.createElement('img');
    img.src = swatch.dataset.image;
    img.className = 'swatch-preview';
    img.style.cssText = 'position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; z-index: 10;';
    media.appendChild(img);
  });

  document.addEventListener('mouseout', function(e) {
    var swatch = e.target.closest('.product-card__swatch[data-image]');
    if (!swatch) return;
    var card = swatch.closest('.product-card');
    var media = card.querySelector('.product-card__media');
    if (!media) return;
    var existing = media.querySelector('.swatch-preview');
    if (existing) existing.remove();
  });
  /* ---------- Expose EP namespace ---------- */
  window.EP = {
    openCart:    openCart,
    closeCart:   closeCart,
    refreshCart: refreshCartCount,
    reloadCart:  reloadCartDrawer
  };

})();